import { Component, Input } from '@angular/core';

export interface IDataInterface {
  type?: string,
  settings?: ISettingsInterface
}

export interface ISettingsInterface {
  heading?: string
  accordionItems?: Array<IAccordionItemsInterface>
}

export interface IAccordionItemsInterface {
  title?: string
  content?: string
}
@Component({
  selector: 'app-product-accordion',
  templateUrl: './product-accordion.component.html',
  styleUrls: ['./product-accordion.component.scss']
})
export class ProductAccordionComponent {
  @Input() data!: IDataInterface;
}
